/** Validation rules for portfolio-owned venture create (name + website). */

export type TranslateFn = (key: string) => string

const COMPANY_URL_PATTERN =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/

export function portfolioVentureNameRules(t: TranslateFn) {
  const prefix = 'companyPerspective.registrationPage.'
  return [
    (v: string) => !!v || t(`${prefix}companyNameIsRequired`),
    (v: string) =>
      (v && v.length <= 100) || t(`${prefix}companyNameMustBeLessThan`),
  ]
}

export function portfolioVentureWebsiteRules(t: TranslateFn) {
  const prefix = 'companyPerspective.registrationPage.'
  return [
    (v: string) =>
      !v || COMPANY_URL_PATTERN.test(v) || t(`${prefix}urlIsNotValid`),
  ]
}

export function portfolioVentureInviteEmailRules(t: TranslateFn) {
  const prefix = 'companyPerspective.registrationPage.'
  return [
    (v: string) =>
      !v || /.+@.+\..+/.test(v) || t(`${prefix}emailMustBeValid`),
  ]
}
